export const routes = {
  DASHBOARD: '/dashboard',
  LANDING_PAGE: '/',
}
